import {useMutation, useQuery} from '@tanstack/react-query';
import {
  getAccessControlListData,
  SaveAccessControlList,
} from '../../api/endpoints/securityGroupApi';
import {
  AccessControlResponse,
  SecurityGroupRequest,
} from '../../api/types/securityGroup.types';

export const useGetAccessControlListData = (key: string) => {
  return useQuery<AccessControlResponse, Error>({
    queryKey: ['accessControlListData', key],
    queryFn: () => getAccessControlListData(key),
    enabled: !!key,
    retry: 2,
  });
};
export const useSaveAccessControlListData = () => {
  return useMutation({
    mutationFn: (payload: SecurityGroupRequest) =>
      SaveAccessControlList(payload),
  });
};
